import { type ServiceParams, unwrapJson } from "../client";
import type {
  AllowedOriginAddPayload,
  AllowedOriginsResponse,
} from "./types";

/**
 * CORS allowed-origins service. List + add + remove on
 * ``/v1/governance/cors/allowed-origins`` (tenant-admin gated).
 *
 * Mutations pass ``config()`` directly — DO NOT spread the Headers
 * object (see v0.38.2 regression-guard: spreading a ``Headers``
 * instance into an object literal yields ``{}`` and drops
 * Authorization).
 */
const Cors = ({ url, config }: ServiceParams) => {
  const base = `${url}/v1/governance/cors/allowed-origins`;

  return {
    async list(): Promise<AllowedOriginsResponse> {
      const response = await fetch(base, {
        method: "GET",
        headers: config(),
      });
      return unwrapJson<AllowedOriginsResponse>(response);
    },

    async add(
      payload: AllowedOriginAddPayload
    ): Promise<AllowedOriginsResponse> {
      const response = await fetch(base, {
        method: "POST",
        headers: config(),
        body: JSON.stringify(payload),
      });
      return unwrapJson<AllowedOriginsResponse>(response);
    },

    async remove(
      payload: AllowedOriginAddPayload
    ): Promise<AllowedOriginsResponse> {
      const response = await fetch(base, {
        method: "DELETE",
        headers: config(),
        body: JSON.stringify(payload),
      });
      return unwrapJson<AllowedOriginsResponse>(response);
    },
  };
};

export default Cors;
